/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../../../utils/config';

export const SEARCH_LTE_USERS = `${API_URL}/open5gs/searchByimsi`;
